import * as yup from "yup";
import { getCustomerEmailYupRule } from "js/jsx/src/classes/quote/validation/customerEmailValidation";

export const editCustDetailsFormValidationSchema = yup.object().shape({
	phone: yup.string().trim().max(30, "Phone must not be greater than 30 characters long"),
	email: getCustomerEmailYupRule(),
	fullName: yup
		.string()
		.trim()
		.required("Contact is a required field")
		.test("is-valid-fullname", "Contact must have a First Name and Last Name", (value) => {
			const separator = " ";
			const fullNameSubParts = value
				.trim()
				.split(separator)
				.filter((part) => part !== "");
			return fullNameSubParts.length >= 2;
		})
		.max(120, "Contact must not be greater than 120 characters long")
});
